export enum EventMembershipStatuses {
    /**
     * заявка на рассмотрении
     */
    pending = "pending",

    /**
     * участие подтверждено
     */
    confirmed = "confirmed",

    /**
     * участие обязательно
     */
    mandatory = "mandatory",

    /**
     * в участии отказано
     */
    denied = "denied"
}